import { useNotify, useRecordContext, useRefresh } from 'react-admin'
import { client } from '../../../providers/data/client'

export const isTestComplete = (kit) => {
  return kit.labTestedAt > 0
}

export const showAcknowledgeButton = (kit) => {
  if (['pendingConfirmation', 'manualReview'].includes(kit?.status)) return false
  if (kit.labTestResult === 'none') return false

  return true
}

export const markAcknowledgment = async (kit, isAcknowledged, notify, refresh) => {
  notify('Updating acknowledgment...', {
    type: 'info',
    multiLine: true,
  })

  try {
    const response = await client().get(`/provider-portal/results/${kit.kitId}`)
    const providerPortalEmail = localStorage.getItem('provider_portal_customer_email')

    if (!providerPortalEmail) {
      notify('Your provider portal email is unavailable. Please sign in again.', {
        type: 'error',
        multiLine: true,
      })
      return
    }

    if (isAcknowledged) {
      response.data.providerAcknowledgedAt = null
      response.data.providerAcknowledgedBy = null
    } else {
      response.data.providerAcknowledgedAt = Date.now()
      response.data.providerAcknowledgedBy = providerPortalEmail
    }
    await client().put(`/provider-portal/acknowledgeKit/${kit.kitId}`, response.data)
    notify('Acknowledgment Updated', {
      type: 'success',
      multiLine: true,
    })
    refresh()
  } catch (e) {
    let errorMessage = 'Failed to update acknowledgment.'

    if (e.response.data.message) {
      errorMessage = e.response.data.message
    } else if (e.response.data.error) {
      errorMessage = e.response.data.error
    } else if (e.message) {
      errorMessage = e.message
    }

    notify(errorMessage, {
      type: 'error',
      multiLine: true,
    })
  }
}

// Actions

export const ViewTestResultAction = () => {
  const record = useRecordContext()
  const notify = useNotify()
  const refresh = useRefresh()
  const acknowledged = record.providerAcknowledgedAt > 0 && record.providerAcknowledgedBy
  return (
    <div>
      {showAcknowledgeButton(record) && (
        <button
          type="button"
          className={`btn-tonal ${acknowledged ? 'btn-tonal-neutral' : 'btn-tonal-success'}`}
          onClick={async () => await markAcknowledgment(record, acknowledged, notify, refresh)}
        >
          <span className={`fa-solid fa-${acknowledged ? 'x' : 'check'}`} aria-hidden="true"></span>
          {acknowledged ? 'Un-acknowledge' : 'Acknowledge'}
        </button>
      )}
    </div>
  )
}
